import React from 'react';

const ChartCard = ({ info,firstCard }) => {
    return (
        <div className="col-12">
            <div className={`pt-4 ${!firstCard && "chart-cart"} `}>
                <h5 className="blue-text" > {info?.info_title}</h5>
                <p className="body-text">{info?.descreption1}</p>
                <p className="body-text" >{info?.description2}</p>
            </div>
        </div>
    );
};

export default ChartCard;